<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="课件名称">
          <el-input placeholder="请输入课件名称" v-model="formInline.name"></el-input>
        </el-form-item>
        
        <!-- 所属组织 -->
        <el-form-item label="所属组织">
          <el-select 
            v-model="formInline.ma_company_id" 
            placeholder="请选择所属组织"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
        
        <!-- 所属行业：多选级联 -->
        <el-form-item label="所属行业">
          <el-cascader
            v-model="formInline.industry_ids"
            :options="industryTree"
            :props="industryCascaderProps"
            placeholder="请选择所属行业"
            clearable
            filterable
            style="width: 250px;"
            @change="handleCascaderChange('industry_ids', $event)"
          ></el-cascader>
        </el-form-item>
        
        <!-- 培训类别：多选级联 -->
        <el-form-item label="培训类别">
          <el-cascader
            v-model="formInline.class_ids"
            :options="classTree"
            :props="classCascaderProps"
            placeholder="请选择培训类别"
            clearable
            filterable
            style="width: 250px;"
            @change="handleCascaderChange('class_ids', $event)"
          ></el-cascader>
        </el-form-item>
        
        <!-- 课件目录：单层级联 -->
        <el-form-item label="课件目录">
          <el-cascader
            v-model="formInline.directory_id"
            :options="directoryTree"
            :props="directoryCascaderProps"
            placeholder="请选择目录"
            clearable
            filterable
            style="width: 250px;"
          ></el-cascader>
        </el-form-item>
        
        <!-- 课件分类 -->
        <el-form-item label="课件分类">
          <el-select 
            v-model="formInline.courseware_category_id" 
            placeholder="请选择所属分类"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="category in categoryList"
              :key="category.courseware_category_id"
              :label="category.name"
              :value="category.courseware_category_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据统计栏 -->
    <div class="statistics-wrap">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="statistics-card">
            <div class="statistics-title">课件总使用数</div>
            <div class="statistics-number">{{ formatNumber(statsData.totalUseCount) }}次</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="statistics-card">
            <div class="statistics-title">课件总数</div>
            <div class="statistics-number">{{ formatNumber(statsData.totalCount) }}个</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="statistics-card">
            <div class="statistics-title">标新课件数</div>
            <div class="statistics-number">{{ formatNumber(statsData.newCount) }}个</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="statistics-card">
            <div class="statistics-title">本月更新课件数</div>
            <div class="statistics-number">{{ formatNumber(statsData.monthUpdateCount) }}个</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加课件</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="name" label="课件名称"></el-table-column>
            <el-table-column label="课件封面" width="120">
              <template slot-scope="scope">
                <el-image 
                  v-if="scope.row.cover_img"
                  :src="scope.row.cover_img"
                  fit="cover"
                  style="width: 80px; height: 60px; border-radius: 4px;"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size: 20px;"></i>
                  </div>
                </el-image>
                <div v-else style="color: #909399;">暂无封面</div>
              </template>
            </el-table-column>
            <el-table-column prop="ma_organization_name" label="所属组织"></el-table-column>
            <el-table-column prop="courseware_industry_name" label="所属行业"></el-table-column>
            <el-table-column prop="courseware_class_name" label="培训类别"></el-table-column>
            <el-table-column prop="courseware_directory_name" label="课件目录"></el-table-column>
            <el-table-column prop="courseware_category_name" label="课件分类"></el-table-column>
            <el-table-column prop="annex_file" label="上传文件">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :href="scope.row.annex_file"
                  target="_blank"
                >
                  下载文件
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="use_num" label="使用数"></el-table-column>
           
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :courseware_id="courseware_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import CoursewareApi from '@/api/courseware.js';
import Ma_companyApi from '@/api/ma_company.js';
import AfuncApi from '@/api/afunc.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      formInline: {
        name: '',
        ma_company_id: '',
        industry_ids: [], // 所属行业（多选级联）
        class_ids: [], // 培训类别（多选级联）
        directory_id: '', // 课件目录（单选级联）
        courseware_category_id: ''
      },

      // 下拉选项数据
      organizationList: [],
      categoryList: [],
      industryTree: [],
      classTree: [],
      directoryTree: [],
      
      // 级联选择器配置
      industryCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        value: 'courseware_industry_id',
        label: 'name',
        children: 'children',
        emitPath: false, // 这里设为false，只返回最后一级的值
        collapseTags: true,
        clearable: true
      },
      classCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        value: 'courseware_class_id',
        label: 'name',
        children: 'children',
        emitPath: false, // 这里设为false，只返回最后一级的值
        collapseTags: true,
        clearable: true
      },
      directoryCascaderProps: {
        multiple: false,
        checkStrictly: true,
        expandTrigger: 'hover',
        value: 'courseware_directory_id',
        label: 'name',
        children: 'children',
        emitPath: false, // 这里设为false，只返回最后一级的值
        clearable: true
      },

      /* 统计数据 */
      statsData: {
        totalUseCount: 0,
        totalCount: 0,
        newCount: 0,
        monthUpdateCount: 0
      },

      open_add:false,
      open_edit:false,
      courseware_id:"",
      dialogVisible:false,
      open_import:false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
    };
  },
  created() {
    /*初始化数据*/
    this.initData();
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /* 初始化数据 */
    async initData() {
      await this.loadOrganization();
      await this.loadCategory();
      await this.loadTreeData();
    },
    
    /* 加载树形数据 */
    async loadTreeData() {
      try {
        // 加载行业树
        const industryRes = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: 'courseware_industry',
        });
        if (industryRes.code === 1) {
          this.industryTree = industryRes.data.list || [];
        }
        
        // 加载培训类别树
        const classRes = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: 'courseware_class',
        });
        if (classRes.code === 1) {
          this.classTree = classRes.data.list || [];
        }
        
        // 加载目录树
        const directoryRes = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: 'courseware_directory',
        });
        if (directoryRes.code === 1) {
          this.directoryTree = directoryRes.data.list || [];
        }
      } catch (error) {
        console.error('加载树形数据失败:', error);
      }
    },
    
    /* 加载组织列表 */
    async loadOrganization() {
      try {
        const response = await Ma_companyApi.list({}, true);
        
        if (response.code === 1 && response.data.list) {
          this.organizationList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.organizationList = [];
      }
    },
    
    /* 加载课件分类列表 */
    async loadCategory() {
      try {
        const response = await AfuncApi.call({
          model: 'courseware_category',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.categoryList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载课件分类失败:', error);
        this.categoryList = [];
      }
    },
    
    /* 处理级联选择器变化（父子互斥逻辑） */
    handleCascaderChange(field, selectedArr) {
      if (!Array.isArray(selectedArr) || selectedArr.length === 0) {
        this.$set(this.formInline, field, []);
        return;
      }
      
      var selectCopy = JSON.parse(JSON.stringify(selectedArr));
      var finalSelect = [];
      
      selectCopy.sort((a, b) => a.length - b.length);
      
      for (var i = 0; i < selectCopy.length; i++) {
        var currentPath = selectCopy[i];
        var isChild = false;
        
        for (var j = 0; j < finalSelect.length; j++) {
          var existingPath = finalSelect[j];
          
          if (currentPath.length > existingPath.length) {
            var isPrefix = true;
            for (var k = 0; k < existingPath.length; k++) {
              if (currentPath[k] !== existingPath[k]) {
                isPrefix = false;
                break;
              }
            }
            if (isPrefix) {
              isChild = true;
              break;
            }
          }
        }
        
        if (!isChild) {
          finalSelect.push(currentPath);
        }
      }
      
      this.$set(this.formInline, field, finalSelect);
    },
    
    /* 重置搜索条件 */
    resetSearch() {
      this.formInline = {
        name: '',
        ma_company_id: '',
        industry_ids: [],
        class_ids: [],
        directory_id: '',
        courseware_category_id: ''
      };
      this.curPage = 1;
      this.getTableList();
    },

    /* 格式化数字，添加千位分隔符 */
    formatNumber(num) {
      if (typeof num !== 'number') return num;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    dialogFormVisible(){
      this.dialogVisible = false;
    },
    setting(e){//课件标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /* 清空选择 */
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      // 构建导出参数
      let exportParams = {};
      
      // 复制搜索条件到导出参数
      Object.assign(exportParams, this.formInline);
      
      // 处理级联选择器的值（如果emitPath: false，则已经是最後一级ID）
      // 如果是多选数组，需要转换为逗号分隔的字符串
      if (Array.isArray(exportParams.industry_ids)) {
        exportParams.industry_ids = exportParams.industry_ids.join(',');
      }
      if (Array.isArray(exportParams.class_ids)) {
        exportParams.class_ids = exportParams.class_ids.join(',');
      }

      // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.courseware_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      // 使用页面跳转方式导出
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '' && exportParams[key] !== null && exportParams[key] !== undefined)
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.courseware.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = Object.assign({}, this.formInline);
      
      // 处理级联选择器的值
      // 如果emitPath: false，则值已经是最后一级ID
      // 如果选择了多个，则是数组格式，需要转换为逗号分隔的字符串
      if (Array.isArray(Params.industry_ids)) {
        Params.industry_ids = Params.industry_ids.join(',');
      }
      if (Array.isArray(Params.class_ids)) {
        Params.class_ids = Params.class_ids.join(',');
      }
      
      // 去除空值
      Object.keys(Params).forEach(key => {
        if (Params[key] === '' || Params[key] === null || Params[key] === undefined) {
          delete Params[key];
        }
      });
      
      // 构建API请求参数
      let apiParams = {
        name: this.formInline.name,
        ma_company_id: this.formInline.ma_company_id,
        courseware_category_id: this.formInline.courseware_category_id,
        courseware_directory_id: this.formInline.directory_id,
        courseware_industry_id: Params.industry_ids,
        courseware_class_id: Params.class_ids,
        page: self.curPage,
        list_rows: self.pageSize
      };
      
      self.loading = true;
      CoursewareApi.list(apiParams, true)
          .then(data => {
            self.loading = false;
            
            if (data.code === 1) {
              // 获取列表数据
              self.tableData = data.data.list.data || [];
              self.totalDataNumber = data.data.list.total || 0;
              
              // 获取统计数据
              self.statsData = {
                totalUseCount: data.data.list.stats.totalUseCount || 0,
                totalCount: data.data.list.stats.totalCount || 0,
                newCount: data.data.list.stats.newCount || 0,
                monthUpdateCount: data.data.list.stats.monthUpdateCount || 0
              };
            } else {
              self.$message.error(data.msg || '获取数据失败');
            }
          })
          .catch(error => {
            self.loading = false;
            console.error('获取列表失败:', error);
            self.$message.error('获取数据失败，请稍后重试');
          });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.courseware_id = row.courseware_id;
      this.open_edit = true
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CoursewareApi.del(
                {
                  courseware_id: row.courseware_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error(data.msg || '删除失败');
                  }
                })
                .catch(error => {
                  self.$message.error('删除失败');
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style>
/* 数据统计样式 */
.statistics-wrap {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.statistics-card {
  text-align: center;
  padding: 15px 10px;
  border-radius: 8px;
  background: #f5f7fa;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.statistics-card:hover {
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.statistics-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: normal;
}

.statistics-number {
  font-size: 22px;
  color: #409EFF;
  font-weight: bold;
}

/* 不同统计项可以有不同的颜色 */
.statistics-card:nth-child(2) .statistics-number {
  color: #67C23A;
}

.statistics-card:nth-child(3) .statistics-number {
  color: #E6A23C;
}

.statistics-card:nth-child(4) .statistics-number {
  color: #F56C6C;
}

/* 搜索表单样式调整 */
.common-seach-wrap .el-form-item {
  margin-bottom: 15px;
}

/* 级联选择器样式优化 */
.el-cascader__tags {
  flex-wrap: wrap !important;
  white-space: normal !important;
  min-height: 32px;
  line-height: normal;
}

.el-cascader__tag {
  margin: 2px 4px 2px 0 !important;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-cascader__input {
  min-height: 32px !important;
  line-height: 32px !important;
  padding: 0 12px !important;
}

.el-cascader__search-input {
  min-height: 30px !important;
}

.el-cascader__dropdown {
  max-height: 400px !important;
  overflow-y: auto !important;
}

/* 响应式调整 */
@media screen and (max-width: 1600px) {
  .common-seach-wrap .el-form-item {
    margin-right: 10px;
  }
  .common-seach-wrap .el-select,
  .common-seach-wrap .el-cascader {
    width: 180px !important;
  }
}

@media screen and (max-width: 1400px) {
  .common-seach-wrap .el-form-item {
    margin-right: 8px;
  }
  .common-seach-wrap .el-select,
  .common-seach-wrap .el-cascader {
    width: 160px !important;
  }
}

/* 数据加载动画 */
.statistics-loading {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/courseware/index/index.vue